export default __webpack_public_path__ + "static/media/mockupIcon.718d338d.svg";